import React from 'react';
import moment from 'moment';
import { isNullOrUndefined } from 'util';

export default class DateTimeInput extends React.Component {
    constructor(args) {
        super(args);

        this.state = this.createState(this.props);
        this.state.value = this.getPropsValue(this.props);
        this.state.initValue = this.state.value;

        this.calendarButton = null;
    }

    componentDidMount() {
        this.initDateTimePicker();
    }

    componentWillUnmount() {
        if (this.calendarButton) {
            this.calendarButton.off('apply.daterangepicker');
        }
    }

    componentWillReceiveProps(newProps) {
        let newState = this.createState(newProps);
        let needInitDateTimePicker = newState.enableTime !== this.state.enableTime;
        this.setState(newState, () => {
            let newValue = this.getPropsValue(newProps);
            this.setState({
                value: newValue,
                initValue: newValue
            });
            if (needInitDateTimePicker) {
                this.initDateTimePicker();
            } else if (newValue) {
                this.calendarButton.data('daterangepicker').setStartDate(newValue);
                this.calendarButton.data('daterangepicker').setEndDate(newValue);
            }
        });
        
    }

    createState(props) {
        let enableTime = isNullOrUndefined(props.enableTime) ? false : props.enableTime;
        return {
            calendarButtonId: 'calendar-' + this.props.id,
            enableTime: enableTime,
            sendFormat: enableTime ? "YYYY-MM-DDTHH:mm:ss" : "YYYY-MM-DDT00:00:00",
            displayFormat: enableTime ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY"
        };
    }

    getPropsValue(props) {
        return this.clearValue(props.value, null);
    }

    initDateTimePicker() {
        this.calendarButton = $('#' + this.state.calendarButtonId);
        this.calendarButton.daterangepicker(
            {
                "singleDatePicker": true,
                "timePicker": this.state.enableTime,
                "timePicker24Hour": this.state.enableTime,
                "autoApply": false,
                "autoUpdateInput": false,
                "drops": this.props.openDirection,
                "locale": {
                    "format": this.state.displayFormat,
                    "applyLabel": "Применить",
                    "cancelLabel": "Отмена",
                    "fromLabel": "С",
                    "toLabel": "По",
                    "weekLabel": "Н",
                    "daysOfWeek": [
                        "Вс",
                        "Пн",
                        "Вт",
                        "Ср",
                        "Чт",
                        "Пт",
                        "Сб"
                    ],
                    "monthNames": [
                        "Январь",
                        "Февраль",
                        "Март",
                        "Апрель",
                        "Май",
                        "Июнь",
                        "Июль",
                        "Август",
                        "Сентябрь",
                        "Октябрь",
                        "Ноябрь",
                        "Декабрь"
                    ],
                    "firstDay": 1
                }
            },
            (start, end, label) => this.handleDateTimePicked(start)
        );
        if (this.state.value) {
            this.calendarButton.data('daterangepicker').setStartDate(this.state.value);
            this.calendarButton.data('daterangepicker').setEndDate(this.state.value);
        }
        this.calendarButton.on('apply.daterangepicker', (ev, picker) => this.handleDateTimePicked(picker.startDate));
    }

    parseValue(value, format) {
        if (isNullOrUndefined(value)) {
            return null;
        } else {
            let momentValue = null;
            if (isNullOrUndefined(format)) {
                momentValue = moment(value);
            } else {
                momentValue = moment(value, format);
            }
            if (momentValue.isValid()) {
                return momentValue;
            } else {
                return null;
            }
        }
    }

    clearValue(value, format) {
        let parsedValue = this.parseValue(value, format);
        if (parsedValue) {
            return parsedValue.format(this.state.displayFormat);
        } else {
            return "";
        }
    }

    saveValue(value) {
        let newValue = value ? value.format(this.state.displayFormat) : "";
        if (newValue === this.state.initValue) {
            return;
        }

        this.setState({
            value: newValue,
            initValue: newValue
        });

        let sendValue = value ? value.format(this.state.sendFormat) : null;
        sendValue = sendValue === "" ? null : sendValue;
        if (this.props.onChange) {
            this.props.onChange(sendValue);
        }
    }

    handleDateTimePicked(newValue) {
        this.saveValue(newValue);
        this.handleInputBlur();
    }

    handleInputValueChanged(e) {
        let rawValue = e.target.value;
        if (this.calendarButton) {
            let parsedValue = this.parseValue(rawValue, this.state.displayFormat);
            if (parsedValue) {
                this.calendarButton.data('daterangepicker').setStartDate(parsedValue);
                this.calendarButton.data('daterangepicker').setEndDate(parsedValue);
            }
        }
        this.setState({ value: rawValue });
    }

    handleInputBlur() {
        let displayValue = this.clearValue(this.state.value, this.state.displayFormat);
        let value = displayValue.length > 0 ? moment(displayValue, this.state.displayFormat) : null;
        this.saveValue(value);
        if (this.props.onEditComplete) {
            this.props.onEditComplete();
        }
    }

    handleInputKeyDown(e) {
        if (e.keyCode === 13) {
            this.handleInputBlur();
        }
    }

    renderCalendarIcon() {
        return (
            <span className={"input-group-addon fake-button-addon " + (this.props.disabled === true ? 'disabled' : '')} 
                id={this.state.calendarButtonId}><i className="fa fa-calendar"></i></span>
        );
    }

    render() {
        let isStartIcon = this.props.isStartIcon ? true : false;
        return (
            <div className={"input-group " + (this.props.className ? this.props.className : "")}>
                {(isStartIcon && this.renderCalendarIcon(this.props.disabled))}
                <input type="text"
                    className="form-control"
                    id={this.props.id}
                    title={this.props.title}
                    value={this.state.value}
                    onChange={e => this.handleInputValueChanged(e)}
                    onBlur={() => this.handleInputBlur()}
                    onKeyDown={e => this.handleInputKeyDown(e)}
                    disabled={this.props.disabled}
                />
                {(!isStartIcon && this.renderCalendarIcon(this.props.disabled))}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/controls/dateTimeInput.jsx